import { SortInput } from 'components/Table'
import { WorkspaceBidderSortInput } from './api/types'

export const DEFAULT_SORT: SortInput<WorkspaceBidderSortInput> = {
  by: 'bidderCode',
  direction: 'asc',
}
